import { AuthSessionKey } from './sessionStorageKey'

export function storeSessionWithKey(key: string, value: string) {
  window.sessionStorage.setItem(key, value)
}

export function getSessionWithKey(key: string) {
  return window.sessionStorage.getItem(key)
}

export function clearSessionItemByKey(key: string) {
  window.sessionStorage.removeItem(key)
}

export function clearAllSession() {
  window.sessionStorage.clear()
}

export function shouldUseSession(key: string) {
  return Boolean(AuthSessionKey[key])
}
